"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.REPORTS_API_URL = exports.AUTHORING_API_URL = exports.ITEMS_API_URL = void 0;
exports.ITEMS_API_URL = 'https://items.learnosity.com/?v2023.3.LTS';
exports.AUTHORING_API_URL = 'https://authorapi.learnosity.com/?v2023.3.LTS';
exports.REPORTS_API_URL = 'https://reports-va.learnosity.com/?v2023.3.LTS';
